// ==================== AUTH CONTEXT DEFINITION ====================

import { createContext } from 'react';
import type { User, AuthTokens, LoginCredentials, RegisterData } from '../../types';

// ==================== TYPES ====================

export interface AuthContextType {
  user: User | null;
  tokens: AuthTokens | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
  login: (credentials: LoginCredentials) => Promise<boolean>;
  register: (data: RegisterData) => Promise<{ success: boolean; message: string }>;
  logout: () => void;
  clearError: () => void;
  refreshUser: () => Promise<void>;
  updateTokens: (newTokens: AuthTokens) => void;
  updateUser: (user: User) => void;
}

// ==================== CONTEXT ====================

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

